export class AuditTrail {
        public auditTrailId: number = 0;
        public shipmentsId: number = 0;
        public fieldName: string = null;
        public oldValue: string = "None";
        public newValue: string = null;
}
